(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_faq"] && !Shopify.designMode) return;
  try {
    
      // Product Page FAQ Section
    window.onload = function() {
    let FaqData = document.querySelectorAll(".faqBlock .Item");

    FaqData.forEach(function(item) {
      let title = item.querySelector("h3").textContent;
      let desc = item.querySelector("p").innerHTML;

      let collapsible = document.createElement("div");
      collapsible.classList.add("Collapsible");

      let button = document.createElement("button");
      button.classList.add("Collapsible__Button", "Heading", "u-h6");
      button.setAttribute("data-action", "toggle-collapsible");
      button.setAttribute("aria-expanded", "false");
      button.textContent = title;

      let span = document.createElement("span");
      span.classList.add("Collapsible__Plus");
      button.appendChild(span);

      let innerDiv = document.createElement("div");
      innerDiv.classList.add("Collapsible__Inner");

      let contentDiv = document.createElement("div");
      contentDiv.classList.add("Collapsible__Content");
      contentDiv.innerHTML = desc;

      innerDiv.appendChild(contentDiv);
      collapsible.appendChild(button);
      collapsible.appendChild(innerDiv);

      document.querySelector(".faqSection .faqBlock").appendChild(collapsible);
      item.parentNode.removeChild(item);
    });

    // Add event listener for toggling collapsible elements
    let collapsibleButtons = document.querySelectorAll("[data-action='toggle-collapsible']");

    collapsibleButtons.forEach(function(button) {
      button.addEventListener("click", function() {
        let collapsibleInner = this.nextElementSibling;
        let expanded = this.getAttribute("aria-expanded");

        if (expanded === "true") {
          collapsibleInner.style.visibility = "hidden";
          collapsibleInner.style.height = "0";
          this.setAttribute("aria-expanded", "false");
        } else {
          // Hide other open collapsibles before expanding this one
          let openCollapsibles = document.querySelectorAll(".Collapsible__Inner[style*='visible']");

          openCollapsibles.forEach(function(collapsible) {
            collapsible.style.visibility = "hidden";
            collapsible.style.height = "0";
            collapsible.previousElementSibling.setAttribute("aria-expanded", "false");
          });

          collapsibleInner.style.visibility = "visible";
          collapsibleInner.style.height = "auto";
          this.setAttribute("aria-expanded", "true");
        }
      });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery-info"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const mainContainer = document.getElementById('mainMediaContainer');
    const thumbnails = Array.from(document.querySelectorAll('.thumbnail-wrapper'));
    const slider = document.getElementById('thumbnailSlider');
    const leftArrow = document.querySelector('.left-arrow');
    const rightArrow = document.querySelector('.right-arrow');
    const scrollAmount = 120;

    let activeIndex = thumbnails.findIndex((t) => t.classList.contains('active')) || 0;

    // Style media consistently
    function setImageStyle(el) {
      el.style.position = 'absolute'; // prevent pushing layout
      el.style.top = '0';
      el.style.left = '0';
      el.style.width = '100%';
      el.style.height = '100%';
      el.style.objectFit = 'contain';
      el.style.borderRadius = '8px';
      el.style.willChange = 'transform';
      el.style.transition = 'transform 0.35s ease';
    }

    // Setup container so we can layer images
    mainContainer.style.position = 'relative';
    mainContainer.style.overflow = 'hidden';
    mainContainer.style.minHeight = '400px'; // prevent collapse when empty

    function showMedia(index, direction = 0) {
      if (index < 0) index = thumbnails.length - 1;
      if (index >= thumbnails.length) index = 0;
      activeIndex = index;

      const thumb = thumbnails[index];
      const type = thumb.dataset.type;

      const newEl = createMediaElement(thumb, type);
      setImageStyle(newEl);
      newEl.style.transform = `translateX(${direction > 0 ? '100%' : '-100%'})`;
      mainContainer.appendChild(newEl);

      const currentEl = mainContainer.querySelector('.active-media');
      if (currentEl) {
        currentEl.style.transform = `translateX(${direction > 0 ? '-100%' : '100%'})`;
        currentEl.classList.remove('active-media');
        setTimeout(() => currentEl.remove(), 350);
      }

      // Animate new media into place
      requestAnimationFrame(() => {
        newEl.classList.add('active-media');
        newEl.style.transform = 'translateX(0)';
      });

      // Highlight the correct thumbnail
      thumbnails.forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');

      // Auto-scroll the thumbnail bar to keep it visible
      slider.scrollTo({ left: thumb.offsetLeft - 30, behavior: 'smooth' });

      // Re-bind gestures for new element
      bindSwipe(newEl);
      bindMainClick(newEl);
    }

    function createMediaElement(thumb, type) {
      let el;
      if (type === 'image') {
        el = document.createElement('img');
        el.src = thumb.dataset.full;
      } else if (type === 'video') {
        el = thumb.querySelector('video').cloneNode(true);
        el.removeAttribute('muted');
        el.setAttribute('controls', 'true');
        el.setAttribute('autoplay', 'true');
        el.play();
      } else if (type === 'external_video') {
        el = thumb.querySelector('iframe').cloneNode(true);
        el.style.width = '100%';
      }
      return el;
    }

    function bindMainClick(mediaEl) {
      if (!mediaEl) return;
      mediaEl.style.cursor = 'pointer';
      mediaEl.onclick = () => showMedia(activeIndex + 1, 1);
    }

    function bindSwipe(mediaEl) {
      if (!mediaEl) return;

      let startX = 0,
        currentX = 0,
        isDragging = false;

      mediaEl.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        mediaEl.style.transition = 'none';
      });

      mediaEl.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX - startX;
        mediaEl.style.transform = `translateX(${currentX}px)`;
      });

      mediaEl.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        const threshold = 70;
        mediaEl.style.transition = 'transform 0.3s ease';

        if (currentX > threshold) {
          mediaEl.style.transform = 'translateX(100%)';
          setTimeout(() => showMedia(activeIndex - 1, -1), 150);
        } else if (currentX < -threshold) {
          mediaEl.style.transform = 'translateX(-100%)';
          setTimeout(() => showMedia(activeIndex + 1, 1), 150);
        } else {
          mediaEl.style.transform = 'translateX(0)';
        }
        currentX = 0;
      });
    }

    // Initialize with first media
    const firstMedia = mainContainer.querySelector('img, video, iframe');
    if (firstMedia) {
      firstMedia.classList.add('active-media');
      setImageStyle(firstMedia);
      firstMedia.style.transform = 'translateX(0)';
      bindSwipe(firstMedia);
      bindMainClick(firstMedia);
    }

    thumbnails.forEach((thumb, idx) => {
      thumb.addEventListener('click', () => showMedia(idx, idx > activeIndex ? 1 : -1));
    });

    leftArrow.addEventListener('click', () => slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));
    rightArrow.addEventListener('click', () => slider.scrollBy({ left: scrollAmount, behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();
})();
